// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__3q-xn","table__container":"styles_table__container__15vOx","answer":"styles_answer__o-mZX","sortable":"styles_sortable__3CeVK"};